<script>
  import axios from "axios";
  import { session } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });

  export let mac;
  export let server;
  let data = false;
  let loading = false;
  function fetchSRV() {
    loading = true;
    axios
      .post(
        settings.url + "/sipade/hotspot-mac?authorization=" + settings.token,
        {
          server: server,
          mac: mac,
        }
      )
      .then(function (response) {
        loading = false;
        data = response.data;
      })
      .catch(function (error) {
        loading = false;
        data = false;
      });
  }

  fetchSRV();
</script>

{#if data}
  {data.comment}
{:else if loading}
  <span class="animate-pulse">memuat info...</span>
{:else}
  Tanpa Nama Perangkat
{/if}
